/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult,
    SearchSuggestion
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function bulkAddToCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function bulkAddToCartInput(cartId: string, bulkOrderLines: DataServiceEntities.IBulkOrderEntity[]): IDataServiceRequest {
    const query = bulkAddToCartQuery();
    return query.createDataServiceRequestForOperation(
        'BulkAddToCart',
        true,
        DataServiceEntities.BulkAddToCartResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IBulkAddToCartResponse' },
        {
            cartId: cartId,
            bulkOrderLines: bulkOrderLines
        }
    );
}

export function bulkAddToCartAsync(
    context: IContext,
    cartId: string,
    bulkOrderLines: DataServiceEntities.IBulkOrderEntity[]
): AsyncResult<DataServiceEntities.IBulkAddToCartResponse> {
    const request = bulkAddToCartInput(cartId, bulkOrderLines);
    return callActionOrExecute<DataServiceEntities.IBulkAddToCartResponse>(request, context.callerContext);
}

function getLineDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getLineDetailsInput(customer: string, cartLineProduct: DataServiceEntities.ICartLineProductEntity): IDataServiceRequest {
    const query = getLineDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetLineDetails',
        true,
        DataServiceEntities.CartLineProductEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICartLineProductEntity' },
        {
            customer: customer,
            cartLineProduct: cartLineProduct
        }
    );
}

export function getLineDetailsAsync(
    context: IContext,
    customer: string,
    cartLineProduct: DataServiceEntities.ICartLineProductEntity
): AsyncResult<DataServiceEntities.ICartLineProductEntity> {
    const request = getLineDetailsInput(customer, cartLineProduct);
    return callActionOrExecute<DataServiceEntities.ICartLineProductEntity>(request, context.callerContext);
}

function getCartWeightQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCartWeightInput(customer: string, cartLineProducts: DataServiceEntities.ICartLineProductEntity[]): IDataServiceRequest {
    const query = getCartWeightQuery();
    return query.createDataServiceRequestForOperation(
        'GetCartWeight',
        true,
        DataServiceEntities.CartDetailEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICartDetailEntity' },
        {
            customer: customer,
            cartLineProducts: cartLineProducts
        }
    );
}

export function getCartWeightAsync(
    context: IContext,
    customer: string,
    cartLineProducts: DataServiceEntities.ICartLineProductEntity[]
): AsyncResult<DataServiceEntities.ICartDetailEntity> {
    const request = getCartWeightInput(customer, cartLineProducts);
    return callActionOrExecute<DataServiceEntities.ICartDetailEntity>(request, context.callerContext);
}

function createCPNQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function createCPNInput(entityData: DataServiceEntities.ICMACCustomerPartNumberEntity): IDataServiceRequest {
    const query = createCPNQuery();
    return query.createDataServiceRequestForOperation(
        'CreateCPN',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            entityData: entityData
        }
    );
}

export function createCPNAsync(context: IContext, entityData: DataServiceEntities.ICMACCustomerPartNumberEntity): AsyncResult<number> {
    const request = createCPNInput(entityData);
    return callActionOrExecute<number>(request, context.callerContext);
}

function updateCPNQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateCPNInput(updatedEntity: DataServiceEntities.ICMACCustomerPartNumberEntity): IDataServiceRequest {
    const query = updateCPNQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateCPN',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            updatedEntity: updatedEntity
        }
    );
}

export function updateCPNAsync(context: IContext, updatedEntity: DataServiceEntities.ICMACCustomerPartNumberEntity): AsyncResult<boolean> {
    const request = updateCPNInput(updatedEntity);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function deleteCPNQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function deleteCPNInput(key: number): IDataServiceRequest {
    const query = deleteCPNQuery();
    return query.createDataServiceRequestForOperation(
        'DeleteCPN',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            key: key
        }
    );
}

export function deleteCPNAsync(context: IContext, key: number): AsyncResult<boolean> {
    const request = deleteCPNInput(key);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function updateCustomerPartNumberQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateCustomerPartNumberInput(
    accountNum: string,
    itemNumber: string,
    inventoryDimensionId: string,
    partNumber: string
): IDataServiceRequest {
    const query = updateCustomerPartNumberQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateCustomerPartNumber',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            AccountNum: accountNum,
            itemNumber: itemNumber,
            inventoryDimensionId: inventoryDimensionId,
            partNumber: partNumber
        }
    );
}

export function updateCustomerPartNumberAsync(
    context: IContext,
    accountNum: string,
    itemNumber: string,
    inventoryDimensionId: string,
    partNumber: string
): AsyncResult<boolean> {
    const request = updateCustomerPartNumberInput(accountNum, itemNumber, inventoryDimensionId, partNumber);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function getCustomerPartNumbersQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerPartNumbersInput(queryResultSettings: IQueryResultSettings, accountNum: string): IDataServiceRequest {
    const query = getCustomerPartNumbersQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCustomerPartNumbers',
        false,
        DataServiceEntities.CMACCustomerPartNumberEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICMACCustomerPartNumberEntity' },
        {
            AccountNum: accountNum
        }
    );
}

export function getCustomerPartNumbersAsync(
    context: IContext,
    accountNum: string
): AsyncResult<DataServiceEntities.ICMACCustomerPartNumberEntity[]> {
    const request = getCustomerPartNumbersInput(context.queryResultSettings || {}, accountNum);
    return callActionOrExecute<DataServiceEntities.ICMACCustomerPartNumberEntity[]>(request, context.callerContext);
}

function getCustomerPartNumberQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerPartNumberInput(accountNum: string, itemNumber: string, variantId: number): IDataServiceRequest {
    const query = getCustomerPartNumberQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerPartNumber',
        false,
        DataServiceEntities.CMACCustomerPartNumberEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICMACCustomerPartNumberEntity' },
        {
            AccountNum: accountNum,
            itemNumber: itemNumber,
            variantId: variantId
        }
    );
}

export function getCustomerPartNumberAsync(
    context: IContext,
    accountNum: string,
    itemNumber: string,
    variantId: number
): AsyncResult<DataServiceEntities.ICMACCustomerPartNumberEntity> {
    const request = getCustomerPartNumberInput(accountNum, itemNumber, variantId);
    return callActionOrExecute<DataServiceEntities.ICMACCustomerPartNumberEntity>(request, context.callerContext);
}

function updateCustomerPreferencesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateCustomerPreferencesInput(customerPreferences: DataServiceEntities.ICustomerPreferences): IDataServiceRequest {
    const query = updateCustomerPreferencesQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateCustomerPreferences',
        true,
        DataServiceEntities.CustomerPreferencesExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomerPreferences' },
        {
            customerPreferences: customerPreferences
        }
    );
}

export function updateCustomerPreferencesAsync(
    context: IContext,
    customerPreferences: DataServiceEntities.ICustomerPreferences
): AsyncResult<DataServiceEntities.ICustomerPreferences> {
    const request = updateCustomerPreferencesInput(customerPreferences);
    return callActionOrExecute<DataServiceEntities.ICustomerPreferences>(request, context.callerContext);
}

function getCustomerPreferencesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerPreferencesInput(customerAccount: string): IDataServiceRequest {
    const query = getCustomerPreferencesQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerPreferences',
        false,
        DataServiceEntities.CustomerPreferencesExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomerPreferences' },
        {
            customerAccount: customerAccount
        }
    );
}

export function getCustomerPreferencesAsync(
    context: IContext,
    customerAccount: string
): AsyncResult<DataServiceEntities.ICustomerPreferences> {
    const request = getCustomerPreferencesInput(customerAccount);
    return callActionOrExecute<DataServiceEntities.ICustomerPreferences>(request, context.callerContext);
}

function searchCustomPartNumbersQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function searchCustomPartNumbersInput(
    queryResultSettings: IQueryResultSettings,
    customerId: string,
    searchText: string
): IDataServiceRequest {
    const query = searchCustomPartNumbersQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SearchCustomPartNumbers',
        true,
        '',
        'true',
        { bypassCache: 'get', returnEntity: 'SearchSuggestion' },
        {
            customerId: customerId,
            searchText: searchText
        }
    );
}

export function searchCustomPartNumbersAsync(context: IContext, customerId: string, searchText: string): AsyncResult<SearchSuggestion[]> {
    const request = searchCustomPartNumbersInput(context.queryResultSettings || {}, customerId, searchText);
    return callActionOrExecute<SearchSuggestion[]>(request, context.callerContext);
}

function getDocumentAsyncQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getDocumentAsyncInput(documentName: string): IDataServiceRequest {
    const query = getDocumentAsyncQuery();
    return query.createDataServiceRequestForOperation(
        'GetDocumentAsync',
        true,
        DataServiceEntities.DocumentDataEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDocumentDataEntity' },
        {
            documentName: documentName
        }
    );
}

export function getDocumentAsyncAsync(context: IContext, documentName: string): AsyncResult<DataServiceEntities.IDocumentDataEntity> {
    const request = getDocumentAsyncInput(documentName);
    return callActionOrExecute<DataServiceEntities.IDocumentDataEntity>(request, context.callerContext);
}

function getInventoryQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getInventoryInput(sku: string): IDataServiceRequest {
    const query = getInventoryQuery();
    return query.createDataServiceRequestForOperation(
        'GetInventory',
        true,
        DataServiceEntities.StockEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IStockEntity' },
        {
            sku: sku
        }
    );
}

export function getInventoryAsync(context: IContext, sku: string): AsyncResult<DataServiceEntities.IStockEntity> {
    const request = getInventoryInput(sku);
    return callActionOrExecute<DataServiceEntities.IStockEntity>(request, context.callerContext);
}

function getInvoiceQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getInvoiceInput(invoiceId: string, customerAccount: string): IDataServiceRequest {
    const query = getInvoiceQuery();
    return query.createDataServiceRequestForOperation(
        'GetInvoice',
        true,
        DataServiceEntities.DocumentDataEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDocumentDataEntity' },
        {
            invoiceId: invoiceId,
            customerAccount: customerAccount
        }
    );
}

export function getInvoiceAsync(
    context: IContext,
    invoiceId: string,
    customerAccount: string
): AsyncResult<DataServiceEntities.IDocumentDataEntity> {
    const request = getInvoiceInput(invoiceId, customerAccount);
    return callActionOrExecute<DataServiceEntities.IDocumentDataEntity>(request, context.callerContext);
}

function getLeadTimeInformationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getLeadTimeInformationInput(
    queryResultSettings: IQueryResultSettings,
    accountNumber: string,
    deliveryModeId: string,
    productId: number,
    isCustomerPickup: boolean,
    inventoryLevel: string
): IDataServiceRequest {
    const query = getLeadTimeInformationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetLeadTimeInformation',
        true,
        DataServiceEntities.LeadTimeDataEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ILeadTimeDataEntity' },
        {
            accountNumber: accountNumber,
            deliveryModeId: deliveryModeId,
            productId: productId,
            isCustomerPickup: isCustomerPickup,
            inventoryLevel: inventoryLevel
        }
    );
}

export function getLeadTimeInformationAsync(
    context: IContext,
    accountNumber: string,
    deliveryModeId: string,
    productId: number,
    isCustomerPickup: boolean,
    inventoryLevel: string
): AsyncResult<DataServiceEntities.ILeadTimeDataEntity[]> {
    const request = getLeadTimeInformationInput(
        context.queryResultSettings || {},
        accountNumber,
        deliveryModeId,
        productId,
        isCustomerPickup,
        inventoryLevel
    );
    return callActionOrExecute<DataServiceEntities.ILeadTimeDataEntity[]>(request, context.callerContext);
}

function getAvailableDatesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getAvailableDatesInput(leadDate: string, leadTimeDays: number): IDataServiceRequest {
    const query = getAvailableDatesQuery();
    return query.createDataServiceRequestForOperation(
        'GetAvailableDates',
        true,
        DataServiceEntities.GetAvailableDatesResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetAvailableDatesResponse' },
        {
            leadDate: leadDate,
            leadTimeDays: leadTimeDays
        }
    );
}

export function getAvailableDatesAsync(
    context: IContext,
    leadDate: string,
    leadTimeDays: number
): AsyncResult<DataServiceEntities.IGetAvailableDatesResponse> {
    const request = getAvailableDatesInput(leadDate, leadTimeDays);
    return callActionOrExecute<DataServiceEntities.IGetAvailableDatesResponse>(request, context.callerContext);
}

function getTableDataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getTableDataInput(tableName: string, columns: string[], rowCount: number): IDataServiceRequest {
    const query = getTableDataQuery();
    return query.createDataServiceRequestForOperation(
        'GetTableData',
        true,
        DataServiceEntities.ReadTableDataEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IReadTableDataEntity' },
        {
            tableName: tableName,
            columns: columns,
            rowCount: rowCount
        }
    );
}

export function getTableDataAsync(
    context: IContext,
    tableName: string,
    columns: string[],
    rowCount: number
): AsyncResult<DataServiceEntities.IReadTableDataEntity> {
    const request = getTableDataInput(tableName, columns, rowCount);
    return callActionOrExecute<DataServiceEntities.IReadTableDataEntity>(request, context.callerContext);
}

function getSalesRepInformationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getSalesRepInformationInput(accountNumber: string): IDataServiceRequest {
    const query = getSalesRepInformationQuery();
    return query.createDataServiceRequestForOperation(
        'GetSalesRepInformation',
        true,
        DataServiceEntities.CustomerSalesRepEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomerSalesRepEntity' },
        {
            accountNumber: accountNumber
        }
    );
}

export function getSalesRepInformationAsync(
    context: IContext,
    accountNumber: string
): AsyncResult<DataServiceEntities.ICustomerSalesRepEntity> {
    const request = getSalesRepInformationInput(accountNumber);
    return callActionOrExecute<DataServiceEntities.ICustomerSalesRepEntity>(request, context.callerContext);
}

function getToleranceCodesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getToleranceCodesInput(): IDataServiceRequest {
    const query = getToleranceCodesQuery();
    return query.createDataServiceRequestForOperation(
        'GetToleranceCodes',
        false,
        DataServiceEntities.GetToleranceCodeResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetToleranceCodeResponse' },
        {}
    );
}

export function getToleranceCodesAsync(context: IContext): AsyncResult<DataServiceEntities.IGetToleranceCodeResponse> {
    const request = getToleranceCodesInput();
    return callActionOrExecute<DataServiceEntities.IGetToleranceCodeResponse>(request, context.callerContext);
}

function simplePingPostQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingPostInput(): IDataServiceRequest {
    const query = simplePingPostQuery();
    return query.createDataServiceRequestForOperation('SimplePingPost', true, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingPostAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingPostInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function simplePingGetQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function simplePingGetInput(): IDataServiceRequest {
    const query = simplePingGetQuery();
    return query.createDataServiceRequestForOperation('SimplePingGet', false, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function simplePingGetAsync(context: IContext): AsyncResult<boolean> {
    const request = simplePingGetInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

// @ts-ignore
function allowedDaysByZipControllerQuery(rECID?: number): DataServiceQuery {
    const key = rECID ? { RECID: rECID } : null;
    return new DataServiceQuery(
        'AllowedDaysByZipController',
        'PromiseDateEntity',
        DataServiceEntities.PromiseDateEntityExtensionClass,
        key
    );
}

export function createGetAllowedDatesInput(zipCode: string, route: string): IDataServiceRequest {
    const query = allowedDaysByZipControllerQuery();
    return query.createDataServiceRequestForOperation(
        'GetAllowedDates',
        false,
        DataServiceEntities.PromiseDateEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IPromiseDateEntity' },
        { zipCode: zipCode, route: route }
    );
}

export function getAllowedDatesAsync(
    context: IContext,
    zipCode: string,
    route: string
): AsyncResult<DataServiceEntities.IPromiseDateEntity> {
    const request = createGetAllowedDatesInput(zipCode, route);
    return callActionOrExecute<DataServiceEntities.IPromiseDateEntity>(request, context.callerContext);
}

// @ts-ignore
function boundControllerQuery(unusualEntityId?: number): DataServiceQuery {
    const key = unusualEntityId ? { UnusualEntityId: unusualEntityId } : null;
    return new DataServiceQuery('BoundController', 'ExampleEntity', DataServiceEntities.ExampleEntityExtensionClass, key);
}

export function createCreateExampleEntityInput(entityData: DataServiceEntities.IExampleEntity): IDataServiceRequest {
    const query = boundControllerQuery();
    return query.createDataServiceRequestForOperation(
        'CreateExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { entityData: entityData }
    );
}

export function createExampleEntityAsync(context: IContext, entityData: DataServiceEntities.IExampleEntity): AsyncResult<number> {
    const request = createCreateExampleEntityInput(entityData);
    return callActionOrExecute<number>(request, context.callerContext);
}

export function createUpdateExampleEntityInput(
    unusualEntityId: number,
    updatedEntity: DataServiceEntities.IExampleEntity
): IDataServiceRequest {
    const query = boundControllerQuery(unusualEntityId);
    return query.createDataServiceRequestForOperation(
        'UpdateExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { updatedEntity: updatedEntity }
    );
}

export function updateExampleEntityAsync(
    context: IContext,
    unusualEntityId: number,
    updatedEntity: DataServiceEntities.IExampleEntity
): AsyncResult<boolean> {
    const request = createUpdateExampleEntityInput(unusualEntityId, updatedEntity);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createDeleteExampleEntityInput(unusualEntityId: number): IDataServiceRequest {
    const query = boundControllerQuery(unusualEntityId);
    return query.createDataServiceRequestForOperation(
        'DeleteExampleEntity',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {}
    );
}

export function deleteExampleEntityAsync(context: IContext, unusualEntityId: number): AsyncResult<boolean> {
    const request = createDeleteExampleEntityInput(unusualEntityId);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

export function createGetAllExampleEntitiesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = boundControllerQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllExampleEntities',
        false,
        DataServiceEntities.ExampleEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IExampleEntity' },
        {}
    );
}

export function getAllExampleEntitiesAsync(context: IContext): AsyncResult<DataServiceEntities.IExampleEntity[]> {
    const request = createGetAllExampleEntitiesInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IExampleEntity[]>(request, context.callerContext);
}
